import React, { useMemo } from 'react';

import { classnames, margin } from '@lumapps/classnames';
import { FlexBox, Alignment, Theme, ButtonProps } from '@lumapps/lumx/react';

import { useSubscription, UseSubscriptionType } from '../../hooks/useSubscription';
import { UseSubscriptionStatuses } from '../../types';
import { FollowButton } from '../FollowButton';
import { NotificationButton } from '../NotificationButton';

export interface SubscriptionsActionsProps {
    buttonProps?: ButtonProps;
    className?: string;
    isPreview?: boolean;
    scope: string;
    subscription: UseSubscriptionType;
    theme?: Theme;
}

export const SubscriptionsActions: React.FC<SubscriptionsActionsProps> = ({
    buttonProps,
    className,
    isPreview = false,
    scope,
    subscription,
    theme = Theme.light,
}) => {
    const { status, isSubscribed, isNotified, toggleSubscription, toggleNotification } = useSubscription(subscription);

    const isLoading = useMemo(
        () => [UseSubscriptionStatuses.loading, UseSubscriptionStatuses.changing].includes(status),
        [status],
    );

    const previewButtonProps = isPreview ? { style: { pointerEvents: 'none' }, tabIndex: -1 } : undefined;

    return (
        <FlexBox wrap hAlign={Alignment.center} className={className}>
            <FollowButton
                className={classnames({ [margin('right')]: isSubscribed })}
                isSelected={isSubscribed}
                onClick={toggleSubscription}
                disabled={isLoading}
                theme={theme}
                scope={scope}
                {...buttonProps}
                {...previewButtonProps}
            />
            {isSubscribed && !!toggleNotification && (
                <NotificationButton
                    isSelected={isNotified}
                    onClick={toggleNotification}
                    isLoading={isLoading}
                    theme={theme}
                    scope={scope}
                    {...buttonProps}
                    {...previewButtonProps}
                />
            )}
        </FlexBox>
    );
};
